import React, { Component } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql } from "gatsby";

import BlogPostSnippet from "../components/BlogPostSnippet";
import PagesTemplateWithData from "./_template";

export const query = graphql`
query MyQuery {
  allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}) {
    edges {
      node {
        frontmatter {
          slug
          title
          date
          summary
        }
        id
      }
    }
  }
  site {
    siteMetadata {
      siteTitle
    }
  }
}
`;

class BlogIndex extends Component {
    render() {
        const pageLinks = this.props.data.allMarkdownRemark.edges.map(post => <BlogPostSnippet
            key={post.node.id}
            title={post.node.frontmatter.title}
            snippet={post.node.frontmatter.summary}
            url={`/${post.node.frontmatter.slug}`}
            date={post.node.frontmatter.date}
        />);

        return (
            <PagesTemplateWithData>
                <div>
                    <Helmet
                        title={`The Lab, O3's Blog | ${this.props.data.site.siteMetadata.siteTitle}`}
                        meta={[
                            {
                                name: "description",
                                content:
                                    "The latest strategies for customer acquisition, increasing customer satisfaction, and improving employee performance",
                            },
                            {
                                name: "keywords",
                                content:
                                    "O3, perspexi labs, business analytics, customer satisfaction, customer experience, text message surveys, digital health, patient satisfaction, outcome measures",
                            },
                        ]}
                    />

                    <div className="mw8 center pt4 pb3 ph3">
                        <div className="cf mw7 center mb5">
                            <h2
                                className="f-headline ttu lh-solid ba bw2 b--light-gray border-box tc fl w-40-m w-30-l ma0 mt0-ns"
                                style={{ color: "#e94f2c" }}
                            >The <br /> Lab</h2>
                            <h2 className="f3 lh-title light-silver tc fl w-60-m w-70-l mt5-ns pt4-ns">
                                The latest on strategies for customer satisfaction, customer
                                acquisition, and business growth from O3
                            </h2>
                        </div>

                        {pageLinks}
                    </div>
                </div>
            </PagesTemplateWithData>
        );
    }
}

BlogIndex.propTypes = {
    route: PropTypes.shape({
        page: PropTypes.shape({
            path: PropTypes.string.isRequired,
        }).isRequired,
        pages: PropTypes.array.isRequired,
    }).isRequired,
};

export default BlogIndex;
